export function getIndexCardsRoutes() {
  return [
    {
      path: "/indexcards",
      name: "indexcards",
      component: () => import(/* webpackChunkName: indexcards-old-backend */ "./components/IndexCardsOld.vue"),
    },
  ]
}
